import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {LeanPlanningService} from "../../services/lean-planning-service.service";

export class routeActionButtonCtrl implements IController {
  routeId: any;
  onAssign: Function;
  onAssignAndSelect: Function;
  onHandleUnpacked: Function;
  onReoptimize: Function;
  onBlock: Function;
  onUnblock: Function;
  onUpdateBranches: Function;
  onUpdateResource: Function;
  onReset: Function;
  onRemove: Function;
  onChangeRouteColor: Function;
  onManageAssistants: Function;

  public route: any;
  public siteId: any;
  public assignToAgentAction: any = {
    title: 'Assign Route To',
    icon: 'play-outline',
    permission: 'planning.routes.update'
  };
  public actions = [];
  public optimizing: boolean = false;
  public activeActionsMap: any;
  public allowPrintingBillOfLading: boolean;
  public bindingTask: any;
  public printerProvider: string;
  public deliveriesRef: any;

  constructor(private $planningRoutes, private leanPlanningConstants, private splitService: SplitService, private routesService: RoutesService,
              private commonsDialogService: CommonsDialogService, private $deliveries,private leanPlanningService: LeanPlanningService ) {
  }


  $onInit() {
    this.deliveriesRef = this.$deliveries();
    this.printerProvider = this.splitService.getPrinterProvider();
    this.siteId = this.splitService.getSiteId();
  };

  $onChanges(changes) {
    if (changes.routeId && !changes.routeId.isFirstChange()) {
    }
  };

  onOpen($mdMenu, event) {
    const query = {
      expandServices: false,
      expandTasks: true,
      expandTasksExt: true,
    }
    this.$planningRoutes(this.routeId).$asyncValue(query)
      .then((route) => {
        this.route = route;
        this.activeActionsMap = this.leanPlanningService.getRoutesActionsMap([this.route]);
        this._setEditableBoundedEquipment(this.route);
        this.actions = this.route.agentReference ? [this.assignToAgentAction] : [];
        $mdMenu.open(event);
      })

  }

  onPrint() {
    this.routesService.printRoutes([this.route.id]);
  }

  onPrintLoadingSheet() {
    this.routesService.printLoadingSheet([this.route.id]);
  }

  onPrintBillOfLading() {
    this.routesService.onPrintBOL([this.route.id]);
  }

  onDownloadBillOfLading() {
    this.routesService.onDownloadBOL([this.route.id]);
  }

  onPrintIkea() {
    const serviceIds = _.uniq(this.route.routeTaskList.filter(t => t.taskType === 'Stopover').map(t => t.serviceId));
    this.deliveriesRef.$asyncValues(serviceIds)
      .then((services) => {
        this.commonsDialogService.printIkea(services);
      })
  }

  onExport() {
    this.routesService.exportRoutes(
      [this.route.id]);
  }


  private _setEditableBoundedEquipment(route) {
    (route.taskListExt || []).forEach((task: TaskModel) => {
      if (task.subTasks && (task.taskSpec.purpose === 'StartRoute' || task.taskSpec.purpose === 'EndRoute')) {

        const bindingSubTask = _.find(task.subTasks, (st) => {
          return _.find(st.actions, (ac) => {
            return ac.type === "VehicleBinding";
          })!!
        })
        if (!!bindingSubTask) {
          this.bindingTask = task;
        }
      }
    })
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('routeActionButton', {
    bindings: {
      routeId: '<',
      onAssign: '&',
      onAssignAndSelect: '&',
      onHandleUnpacked: '&',
      onReoptimize: '&',
      onBlock: '&',
      onUnblock: '&',
      onReset: '&',
      onUpdateBranches: '&',
      onUpdateResource: '&',
      onUpdateLogisticsVehicle: '&',
      onManageAssistants: '&',
      onRemove: '&',
      onChangeRouteColor: '&'
    },
    template: require('./route-action-button.html').default,
    controller: routeActionButtonCtrl
  });
